import * as React from 'react';
import { Body2, Image, UIHeading5 } from '@cian/ui-kit';

import { INewbuildingSummaryCell } from '../../../../../../types/newbuildingsCompare';
import { NewbuildingCallButton } from '../../../../../../containers/NewbuildingCallButton';
import { NewbuildingChatButton } from '../../../../../../containers/NewbuildingChatButton';
import { NewbuildingDeleteButton } from '../../../../../../containers/NewbuildingDeleteButton';
import { Link } from '../../../../../Link';
import { trackNavigationToCardJK } from '../shared/tracking';
import * as style from './NewbuildingSummaryCellFloating.css';

export interface INewbuildingSummaryCellFloatingProps {
  cell: INewbuildingSummaryCell;
}

export const NewbuildingSummaryCellFloating = ({ cell }: INewbuildingSummaryCellFloatingProps): React.JSX.Element => {
  const { data, state } = cell;

  const handleNavigateToCardJK = React.useCallback(() => {
    if (data) {
      trackNavigationToCardJK(data.id, 'desktop');
    }
  }, [data]);

  if (!data) {
    return <Body2>{state.text ?? ''}</Body2>;
  }

  const { name, fullUrl, imageUrl, priceRange, builders, sellers } = data;
  const hasChat = [...builders, ...sellers].some(contact => contact.chat?.enabled);

  return (
    <div className={style['container']}>
      <Image alt={name} borderRadius="8px" height={56} objectFit="cover" src={imageUrl} width={56} />
      <div className={style['content']}>
        <div className={style['facts']}>
          <div className={style['name']}>
            <Link href={fullUrl} target="_blank" onClick={handleNavigateToCardJK}>
              <UIHeading5 color="text-main-default">{name}</UIHeading5>
            </Link>
          </div>
          {priceRange && (
            <div className={style['price']}>
              <Body2>{priceRange}</Body2>
            </div>
          )}
        </div>
        <div className={style['buttons']}>
          <NewbuildingCallButton
            builders={builders}
            newbuildingId={data.id}
            sellers={sellers}
            size="XS"
            url={fullUrl}
          />
          {hasChat && (
            <NewbuildingChatButton
              builders={builders}
              newbuildingId={data.id}
              sellers={sellers}
              size="XS"
              url={fullUrl}
            />
          )}
        </div>
      </div>
      <NewbuildingDeleteButton iconColor="icon-secondary-default" newbuildingId={data.id} size="XS" />
    </div>
  );
};
